import React, { useEffect, useState } from 'react';
import { Button, Space, Typography, Modal, Select } from 'antd';
import TableWrap from '../../../components/TableWrap';
import './index.scss';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store';
import { getListAnswers } from '../../../store/answers/answerSlice';
import { AnswerInterface } from '../../../interface/answer';

const { Text } = Typography;

const AnswerList: React.FC = () => {
  const answersSlice = useSelector((state: RootState) => state.answer);
  const { data, loading } = answersSlice;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState<AnswerInterface | null>(null);
  const [filterType, setFilterType] = useState<number>(5);
  const [filteredData, setFilteredData] = useState<AnswerInterface[]>(data);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    try {
      dispatch(getListAnswers());
    } catch (error) {
      console.log(`${error}`);
    }
  }, [dispatch]);

  useEffect(() => {
    setFilteredData(data);
  }, [data]);

  const showModal = (record: any) => {
    setSelectedRecord(record);
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
    setSelectedRecord(null);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setSelectedRecord(null);
  };

  const handleChange = (value: number) => {
    setFilterType(value);
  };

  const handleFilter = () => {
    const filteredData = data.filter((item) => item.type === filterType);
    setFilteredData(filteredData);
  };

  const handleReset = () => {
    setFilteredData(data);
    setFilterType(5);
  };

  const columns = [
    {
      title: 'ユーザ名',
      key: 'name',
      dataIndex: 'name',
      render: (_, record) => (
        <Space>
          <img src={record.user.avatar} alt="User" className="image-avatar" />
          <Text>{record.user.name}</Text>
        </Space>
      ),
    },
    {
      title: 'メールアドレス',
      dataIndex: 'email',
      key: 'email',
      render: (_, record) => (
        <Space>
          <Text>{record.user.email}</Text>
        </Space>
      ),
    },
    {
      title: '日別分類',
      key: 'action',
      render: (_, record) => <Text>{record.type}</Text>,
    },
    {
      title: 'アンケートの回答',
      key: 'status',
      render: (_, record) => (
        <Button className="btn-underline" type="primary" onClick={() => showModal(record)}>
          回答結果を閲覧
        </Button>
      ),
    },
  ];

  return (
    <>
      <div className="answer-header">
        <div className="col-left">
          <h5>日間セッティング</h5>
          <Select
            value={filterType}
            style={{ width: 480 }}
            onChange={handleChange}
            suffixIcon={
              <img src="/assets/icons/Caret_Down_SM.svg" alt="custom arrow" style={{ width: 24, height: 24 }} />
            }
            options={[
              { value: 5, label: '5 日間' },
              { value: 20, label: '20 日間' },
            ]}
          />
        </div>
        <div className="col-right">
          <Button className="btn-black" type="primary" onClick={handleFilter}>
            フィルター
          </Button>
          <Button className="btn-border" type="primary" onClick={handleReset}>
            再設定
          </Button>
        </div>
      </div>

      <div className="answer-list">
        <TableWrap
          columns={columns}
          data={filteredData.slice((currentPage - 1) * pageSize, currentPage * pageSize)}
          isLoading={loading}
          total={filteredData.length}
          page={currentPage}
          size={pageSize}
          setPage={(page) => setCurrentPage(page)}
          setSize={(newPageSize) => {
            setPageSize(newPageSize);
            setCurrentPage(1);
          }}
        />
      </div>

      {selectedRecord && (
        <Modal
          width={1124}
          title=""
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={null}
          closable={false}
        >
          <div className="answer-modal-info">
            <Space>
              <img
                src={selectedRecord?.user.avatar}
                alt="User"
                style={{ width: 84, height: 84, borderRadius: '50%' }}
              />
              <div>
                <Text className="bold-text">{selectedRecord?.user.name}</Text>
                <p>{selectedRecord?.user.email}</p>
              </div>
            </Space>
          </div>
          <div className="answer-modal-content">
            {selectedRecord?.questionList.map((ql, idx) => (
              <div key={idx} className="answer-modal-card">
                <h5>質問{idx + 1}</h5>
                <div>
                  <p>{ql.question}</p>
                  <span>回答: </span>
                  <a href="#">{ql.final_answer}</a>
                </div>
              </div>
            ))}
          </div>
          <div style={{ textAlign: 'right', marginTop: 32 }}>
            <Button className="btn-black" type="primary" onClick={handleOk} style={{ marginRight: 12 }}>
              確定
            </Button>
            <Button className="btn-border" onClick={handleCancel}>
              キャンセル
            </Button>
          </div>
        </Modal>
      )}
    </>
  );
};

export default AnswerList;
